import { BillingInfoType } from '@sdk/account/api/AccountApi';

export type SubscriptionUtilsType = {
  getPricePerUnit: (level: number, isYearly: boolean) => number;
  getSubtotal: (billingInfo: BillingInfoType, level: number, isYearly: boolean) => number;
  getProration: (
    billingInfo: BillingInfoType,
    level: number,
    ignoreNextCharge?: boolean,
    isYearly?: boolean
  ) => number;
  getDiscount: (billingInfo: BillingInfoType, level: number, isYearly: boolean) => number;
  getTotal: (
    billingInfo: BillingInfoType,
    level: number,
    ignoreNextCharge?: boolean,
    isYearly?: boolean,
    taxPercent?: number
  ) => number;
  getSubscriptionName: (subscriptionLevel: number) => string;
  getSubscriptionNameDetailed: (subscriptionLevel: number, isOnTrial: boolean) => string;
  // TODO should be refactored to billingInfo
  trialDays: number;
  areYearlySubscriptionsEnabled: (billingInfo: BillingInfoType) => boolean;
};

export enum FeatureNames {
  shiftScheduling = 'Shift scheduling',
  shiftTemplates = 'shiftTemplates',
  alarms = 'alarms',
  shiftOffers = 'Shift offers',
  availableShifts = 'Available shifts',
  timeOff = 'timeOff',
  unavailability = 'unavailability',
  privateMessages = 'privateMessages',
  groupMessages = 'groupMessages',
  announcements = 'Announcements',
  newsSharing = 'News sharing',
  taskManagement = 'Task management',
  longTermScheduling = 'Long term scheduling',
  unlimitedEmployees = 'Unlimited employees',
  multipleLocations = 'Multiple locations',
  timeclock = 'timeclock',
  earlyClockInPrevention = 'Early clock in prevention',
  autoClockOut = 'Auto clock out',
  shiftSwaps = 'Shift swaps',
  slotsOnAvailableShifts = 'Slots on available shifts',
  googleCalendarSync = 'googleCalendarSync',
  dayParts = 'dayParts',
  laborCost = 'laborCost',
  projectedSalesSync = 'projectedSalesSync',
  budgeting = 'Budgeting',
  autoAssigning = 'autoAssigning',
  reports = 'reports',
  noShow = 'noShow',
  kiosk = 'kiosk',
  shiftTags = 'Shift tags',
  smsShiftAlarms = 'SMS shift alarms',
  sickCallout = 'sickCallout',
  lateArrival = 'lateArrival',
  salaries = 'salaries',
  conversationSettings = 'Conversation settings',
  newsfeedPageSettings = 'Newsfeed page settings',
  dedicatedAccountManagement = 'Dedicated account management',
  shiftTasks = 'shiftTasks',
  shiftAcceptance = 'Shift acceptance',
  clopening = 'Clopening',
  scheduleTemplates = 'Schedule templates',
  newsfeed = 'newsfeed',
  clockIn = 'clockIn',
  shiftSlots = 'shiftSlots',
  leaveTypes = 'leaveTypes',
  tags = 'tags',
  messages = 'messages',
  businessClosed = 'businessClosed',
  overtime = 'Overtime tracking',
}

export type BillingAddress = {
  fullName: string;
  city: string;
  line1: string;
  line2: string | null;
  countryCode: string;
  postalCode: string;
  regionCode: string;
};
